<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />
    <!--====== POST LAYOUT 1 PART START ======-->

    <section v-loading="isLoading" class="post-layout-1-area post-layout-2-area pb-80">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="post-layout-top-content post-layout-top-content-2">
              <div class="post-content">
                <h3 class="title">
                  {{article.title}}
                </h3>
              </div>
              <div
                class="
                  post-categories
                  d-flex
                  justify-content-start
                  align-content-center
                "
              >
                <div class="categories-item">
                  <span>HEALTH</span>
                </div>
                <div class="categories-share">
                  <ul>
                    <li><i class="fas fa-comment"></i>45020</li>
                    <li><i class="fas fa-fire"></i>45020</li>
                  </ul>
                </div>
              </div>
              <div class="post-text mt-30">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--====== POST LAYOUT 1 PART ENDS ======-->

    <footer-one />
    <!--====== GO TO TOP PART START ======-->
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
    <!--====== GO TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import Header from "../../Utility/Header/index";
import Posts from "../../Data/TrendingHomeThree";
import FooterOne from "../../Utility/Footer/FooterOne.vue";
import Drawer from "../../Mobile/Drawer.vue";
import { 
  getArticle,
  getArticleMarkdown 
} from "@/api/article"; 
export default {
  components: { Header, FooterOne, Drawer },
  data: () => ({
    Posts: Posts.data,
    sidebar: false,
    isLoading: true,
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.fetchArticleData();
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    async fetchArticleData() {
      const articleId = this.$route.params.id; 
      if (articleId) {
        try {
          const response = await getArticle(articleId);
          this.article = response.data; 
          console.log('article:',this.article);


          this.prevArticle = response.prev;
          this.nextArticle = response.next;
          
          const markdownResponse = await getArticleMarkdown(articleId);
          if (markdownResponse.code === 200) {
            this.markdownBody = markdownResponse.data.body || '';
            this.processedMarkdownBody = this.markdownBody; 
          }
        } catch (error) {
          console.error('获取文章数据失败:', error);
        } finally {
          // 无论请求成功或失败，都结束加载状态
          this.isLoading = false;
        }
      }
    },
  },
};
</script>

<style></style>
